import { TICK_RATE_MS } from '../constants';
import { gameStore } from '../stores/gameStore';
import type { ActiveModal } from '../components/UIOverlay';
import type { GameStatus, QuizQuestion, RandomEvent } from '../types';

export type GameLoopPauseReason = {
  gameStarted: boolean;
  gameStatus: GameStatus;
  activeQuiz: QuizQuestion | null;
  activeEvent: RandomEvent | null;
  activeModal: ActiveModal;
  orgManagementOpen: string | null;
  gameSpeed: number;
};

export function shouldRunTicks(pause: GameLoopPauseReason): boolean {
  const status = gameStore.getState().gameStatus;
  return (
    pause.gameStarted &&
    status === 'playing' &&
    !pause.activeQuiz &&
    !pause.activeEvent &&
    pause.activeModal === 'none' &&
    !pause.orgManagementOpen &&
    pause.gameSpeed > 0
  );
}

/** Fixed-timestep accumulator step — one tick per frame max when threshold met */
export function stepTickAccumulator(
  accumulator: number,
  delta: number,
  tickMs: number
): { accumulator: number; shouldTick: boolean } {
  const next = accumulator + delta;
  if (next >= tickMs) {
    return { accumulator: next % tickMs, shouldTick: true };
  }
  return { accumulator: next, shouldTick: false };
}

export function tickIntervalMs(gameSpeed: number): number {
  return Math.max(100, TICK_RATE_MS / gameSpeed);
}